import React from 'react';
import { Col } from 'react-bootstrap';
import { uniqBy } from 'lodash';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { sourcePath } from '../fieldPath';
import { customStylesForOCP, bomSelection, PIMDisplayFormat } from '../../../Components/helper';

function SourceColumnSection({
  cardEle,
  cardIndex,
  handleChange,
  modalState,
  setSubLocationArr,
  setOptionsForAttribute,
  setOptionsForOutput,
  setOptionsForBomOutput,
  locationOptions,
  setPlacementForLocation,
  measurmentMaster,
  bomTypes,
  sampleTypeGroupList,
}) {
  const { t } = useTranslation('common');

  const OTHER_SAMPLE_OPTION = { name: 'other_sample', label: 'Other Sample' };

  const sampleTypeGroupOptions = uniqBy(
    [
      ...(sampleTypeGroupList ?? [])
        .filter((g) => g.isActive && !g.isDeleted)
        .map((g) => ({ name: g._id, label: g.sampleGroupName })),
      OTHER_SAMPLE_OPTION,
    ],
    'name',
  );

  const getSampleTypeOptions = () => {
    const group = cardEle?.source?.sampleGroupId;
    if (!group) return [];
    if (group.name === 'other_sample') return modalState?.sampleType || [];
    const matched = (sampleTypeGroupList ?? []).find((g) => g._id === group.name);
    return (matched?.sampleTypeAutomation ?? []).map((st) => ({ name: st.sampleType._id, label: st.sampleType.name }));
  };

  const getDynamicBomSelection = () => {
    if (bomTypes && bomTypes.length > 0) {
      const bomTypeOptions = bomTypes.map((bomType) => ({
        label: bomType.name,
        name: bomType._id,
      }));
      return [...bomTypeOptions, ...bomSelection];
    }
    return bomSelection;
  };

  const placementLabel = (ele) => {
    if (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.locationType?.name !== 'all_item') {
      return 'Select Placement';
    }
    return 'Select Position';
  };

  const hideShowAttribute = (ele) => {
    return (
      [
        'Design_Details',
        'Specifications',
        'Testing',
        'Care/User_Document_Information',
        'Costing_Information',
        'Purchase_Order',
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Completion_Indicator',
      ].includes(ele?.source?.location?.name) ||
      (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.locationPlacement) ||
      (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.locationType?.name === 'all_item') ||
      (ele?.source?.location?.name === 'Samples' && ele?.source?.locationPlacement?.name)
    );
  };

  const hideShowplacement = (ele) => {
    return (
      (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.locationType && ele?.source?.locationType?.name !== 'all_item') ||
      (ele?.source?.location?.name === 'Samples' && ele?.source?.locationType?.name)
    );
  };

  const hideShowSubLocation = (ele) => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information'].includes(
        ele?.source?.location?.name,
      ) ||
      (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.locationType?.name !== 'all_item' && ele?.source?.output?.name === 'valueType') ||
      (ele?.source?.location?.name === 'Samples' && ele?.source?.attribute?.name) ||
      (ele?.source?.location?.name === 'Purchase_Order' && ele?.source?.attribute?.name === 'valueType') ||
      (ele?.source?.location?.name === 'Completion_Indicator' && ele?.source?.attribute?.name)
    );
  };

  const hideShowOutput = (ele) => {
    if (ele?.source?.location?.name === 'Bill_of_Materials' && ele?.source?.attribute?.name === 'valueType') {
      return false;
    }
    return (
      (['Design_Details', 'Testing', 'Bill_of_Materials', 'Care/User_Document_Information', 'Custom_Section'].includes(ele?.source?.location?.name) &&
        ele?.source?.attribute?.name) ||
      (ele?.source?.location?.name === 'Purchase_Order' && ele?.source?.attribute?.name === 'all_item')
    );
  };

  let sublocationoptions = [];
  let optionsForAttributae = [];
  let optionsForOutput = [];
  let bomOutputs = [];
  if (cardEle?.source?.location?.name) {
    sublocationoptions = setSubLocationArr(cardEle)?.subLocations;
    optionsForAttributae = setOptionsForAttribute(cardEle);
    optionsForOutput = setOptionsForOutput(cardEle);
    bomOutputs = setOptionsForBomOutput(cardEle);
  }
  return (
    <>
      <Col lg={12}>
        <div className="common-react-select">
          <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.LOCATION')}</p>
          <Select
            options={uniqBy(locationOptions, 'name')}
            value={cardEle.source?.location}
            onChange={(e) =>
              handleChange(e, sourcePath(cardIndex, 'location').SOURCE_KEY_PATH, cardIndex, [
                'subLocation',
                'attribute',
                'output',
                'locationType',
                'locationPlacement',
                'colourCoading',
                'dependentObj',
                'customDurations',
                'pom',
                'displayFormat',
                'sampleGroupId',
              ])
            }
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.name}
            className="common-select"
            maxMenuHeight={140}
            classNamePrefix="common-select"
            placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_LOCATION')}
            menuPlacement="bottom"
            menuPosition="fixed"
            menuShouldBlockScroll
            menuShouldScrollIntoView
            isClearable
          />
          {cardEle.hasError && !cardEle?.source?.location && (
            <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.LOCATION_REQUIRED')}</span>
          )}
        </div>
      </Col>
      {cardEle?.source?.location?.name === 'Samples' && (
        <Col lg="12" className="mb-3">
          <div className="common-react-select">
            <p className="field-name">Sample Type Group</p>
            <Select
              options={sampleTypeGroupOptions}
              value={cardEle?.source?.sampleGroupId}
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'sampleGroupId').SOURCE_KEY_PATH, cardIndex, [
                  'locationType',
                  'subLocation',
                  'attribute',
                  'output',
                  'locationPlacement',
                  'pom',
                  'displayFormat',
                ])
              }
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.name}
              className="common-select"
              maxMenuHeight={140}
              classNamePrefix="common-select"
              placeholder="Select Sample Type Group"
              menuPlacement="bottom"
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              isClearable
            />
            {cardEle.hasError && !cardEle?.source?.sampleGroupId && (
              <span className="error-message">Sample Type Group is required</span>
            )}
          </div>
        </Col>
      )}
      {(cardEle?.source?.location?.name === 'Bill_of_Materials' ||
        (cardEle?.source?.location?.name === 'Samples' && cardEle?.source?.sampleGroupId)) && (
        <Col lg="12" className=" mb-3">
          <div className="common-react-select">
            <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_TYPE')}</p>
            <Select
              isLoading={modalState.loading}
              options={cardEle.source?.location?.name === 'Samples' ? getSampleTypeOptions() : getDynamicBomSelection() || []}
              value={cardEle?.source?.locationType}
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'locationType').SOURCE_KEY_PATH, cardIndex, [
                  'subLocation',
                  'attribute',
                  'output',
                  'locationPlacement',
                  'pom',
                  'displayFormat',
                ])
              }
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.name}
              className="common-select"
              maxMenuHeight={140}
              classNamePrefix="common-select"
              placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_TYPE')}
              menuPlacement="bottom"
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              isClearable
            />
            {cardEle.hasError && !cardEle?.source?.locationType && (
              <span className="error-message">{`${cardEle.source?.location?.name === 'Samples' ? 'Sample Type' : 'BOM Type'} is required`}</span>
            )}
          </div>
        </Col>
      )}
      {hideShowplacement(cardEle) && (
        <Col lg="12" className=" mb-3">
          <div className="common-react-select">
            <p className="asterisk-req field-name">
              {placementLabel(cardEle)} <span>*</span>
            </p>
            <Select
              name="locationPlacement"
              options={setPlacementForLocation(cardEle) || []}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.locationPlacement}
              styles={customStylesForOCP}
              maxMenuHeight={120}
              menuPosition="fixed"
              placeholder={placementLabel(cardEle)}
              classNamePrefix="common-select"
              isLoading={modalState.loading}
              isClearable
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'locationPlacement').SOURCE_KEY_PATH, cardIndex, [
                  'subLocation',
                  'attribute',
                  'output',
                  'customDurations',
                  'dependentObj',
                  'pom',
                  'displayFormat',
                ])
              }
            />
            {cardEle.hasError && !cardEle?.source?.locationPlacement && <span className="error-message">{`${placementLabel(cardEle)} is required.`}</span>}
          </div>
        </Col>
      )}
      {hideShowAttribute(cardEle) && (
        <Col lg={12}>
          <div className="common-react-select">
            <p className="asterisk-req field-name">
              {t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.ATTRIBUTE')} <span>*</span>
            </p>
            <Select
              name="attribute"
              options={optionsForAttributae}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.attribute}
              maxMenuHeight={140}
              menuPlacement="bottom"
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              styles={customStylesForOCP}
              isLoading={modalState.loading}
              classNamePrefix="common-select"
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'attribute').SOURCE_KEY_PATH, cardIndex, ['subLocation', 'output', 'pom', 'displayFormat'])
              }
              placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_ATTRIBUTES')}
            />
            {cardEle.hasError && !cardEle?.source?.attribute && (
              <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.ATTRIBUTE_REQUIRED')}</span>
            )}
          </div>
        </Col>
      )}
      {hideShowOutput(cardEle) && (
        <Col lg={12}>
          <div className="common-react-select">
            <p className="asterisk-req field-name">
              {t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.OUTPUT')} <span>*</span>
            </p>
            <Select
              name="Output"
              options={
                cardEle?.source?.location?.name === t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.BILL_OF_MATERIALS') ? bomOutputs : optionsForOutput
              }
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.output}
              maxMenuHeight={140}
              styles={customStylesForOCP}
              menuPlacement="bottom"
              menuPosition="fixed"
              classNamePrefix="common-select"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_OUTCOME')}
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'output').SOURCE_KEY_PATH, cardIndex, ['subLocation', 'pom', 'displayFormat'])
              }
              isLoading={modalState.loading}
            />
            {cardEle.hasError && !cardEle?.source?.output && (
              <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.OUTPUT_IS_REQUIRED')}</span>
            )}
          </div>
        </Col>
      )}
      {hideShowSubLocation(cardEle) && (
        <Col lg="12">
          <div className="common-react-select">
            <p className="asterisk-req field-name">
              {t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SUB_LOCATION')} <span>*</span>
            </p>
            <Select
              name="SubLocation"
              options={sublocationoptions || []}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.subLocation}
              styles={customStylesForOCP}
              maxMenuHeight={120}
              menuPosition="fixed"
              classNamePrefix="common-select"
              placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SELECT_SUB_LOCATION')}
              isLoading={modalState?.loading}
              onChange={(selected) =>
                handleChange(selected, sourcePath(cardIndex, 'subLocation').SOURCE_KEY_PATH, cardIndex, [
                  'customDurations',
                  'dependentObj',
                  'pom',
                  'displayFormat',
                ])
              }
            />
            {cardEle.hasError && !cardEle?.source?.subLocation && (
              <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.SOURCE_COLUMN_SECTION.SUBLOCATION_REQUIRED')}</span>
            )}
          </div>
        </Col>
      )}
      {cardEle?.source?.subLocation?.name === 'ecomSpec' && (
        <Col lg={12}>
          <div className="common-react-select">
            <label htmlFor="point_measure" className="asterisk-req field-name">
              {t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.POINT_MEASURE')} <span>*</span>
            </label>
            <Select
              name="PointOfMeasure"
              options={measurmentMaster?.map((e) => ({ label: e?.name, name: e?._id })) || []}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.pom}
              styles={customStylesForOCP}
              maxMenuHeight={120}
              menuPosition="fixed"
              classNamePrefix="common-select"
              placeholder={t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.SELECT_SUB_LOCATION')}
              isLoading={modalState?.columnLoading}
              onChange={(selected) => handleChange(selected, sourcePath(cardIndex, 'pom').SOURCE_KEY_PATH, cardIndex)}
            />
            {cardEle.hasError && !cardEle?.source?.pom && (
              <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.POINT_OF_MEASURE_REQUIRED')}</span>
            )}
          </div>
        </Col>
      )}
      {cardEle?.source?.subLocation?.name === 'ecomSpec' && (
        <Col lg="12">
          <div className="common-react-select">
            <label htmlFor="display_format" className="asterisk-req field-name">
              {t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.DISPLAY_FORMAT')}
              <span>*</span>
            </label>
            <Select
              name="DisplayFormat"
              options={PIMDisplayFormat || []}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => `${option.name}`}
              value={cardEle?.source?.displayFormat}
              styles={customStylesForOCP}
              maxMenuHeight={120}
              menuPosition="fixed"
              classNamePrefix="common-select"
              placeholder={t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.SELECT_POINT_MEASURE')}
              isLoading={modalState?.columnLoading}
              onChange={(selected) => handleChange(selected, sourcePath(cardIndex, 'displayFormat').SOURCE_KEY_PATH, cardIndex)}
            />
            {cardEle.hasError && !cardEle?.source?.displayFormat && (
              <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.SOURCE_COLUMN_SECTION.DISPLAY_FORMAT_REQUIRED')}</span>
            )}
          </div>
        </Col>
      )}
    </>
  );
}

export default SourceColumnSection;
